const jwt = require('jsonwebtoken')

const apiUrl = state => state.apiUrl

const websocketUrl = state => state.websocketUrl

const token = state => state.token

const apiHeader = state => {
  return state.token ? { headers: { Authorization: `Bearer ${state.token}` } } : null
}

const user = (state) => {
  const token = state.token

  if (!token) return

  const user = jwt.decode(token)
  if (!user) return

  const issued = new Date(user.iat * 1000)
  const expires = new Date(user.exp * 1000)
  const now = new Date()

  if (issued > now || expires < now) {
    console.error('Invalid JWT dates')
    return
  }

  return {
    id: user.sub,
    name: user.name,
    admin: !!user.admin,
    expiring: new Date(user.exp * 1000)
  }
}

const showSidebar = state => state.showSidebar

const workspaces = state => state.workspaces

const activeWorkspace = state => state.activeWorkspace

const contentplans = state => state.contentplans

const activeContentplan = state => state.activeContentplan

const keywords = state => state.keywords

const crawl = state => state.crawl

const topics = state => state.topics

const articles = state => state.articles
const articlesTotalCount = state => state.articlesTotalCount

const translatedArticles = state => state.translatedArticles

const availableLanguages = state => state.availableLanguages

const article = state => state.article

const articleUrls = state => state.articleUrls

const articleExternalUrls = state => state.articleExternalUrls

const score = state => state.score

const gsc = state => state.gsc

const pages = state => state.pages

const pageKeywords = state => state.pageKeywords

const benchmarks = state => state.benchmarks

const internalLinks = state => state.internalLinks

const integrations = state => state.integrations

const activeIntegration = state => state.activeIntegration

const googleAnalyticsIntegration = state => {
  return state.integrations?.find(item => item.type === 'ga-4') ?? {}
}

const bigQueryIntegration = state => {
  return state.integrations?.find(item => item.type === 'ga-4') ?? {}
}

const wordpressIntegration = state => {
  if (!Array.isArray(state.integrations)) return null
  return state.integrations.find(item => item.type === 'wp-plugin') || state.integrations.find(item => item.type === 'wp') || null
}

const notionIntegration = state => {
  return state.integrations?.find(item => item.type === 'notion') ?? {}
}

const searchConsoleIntegration = state => {
  return state.integrations?.find(item => item.type === 'gsc') ?? {}
}

const webflowIntegration = state => {
  return state.integrations?.find(item => item.type === 'webflow') ?? {}
}

const shopifyIntegration = state => {
  return state.integrations?.find(item => item.type === 'shopify') ?? {}
}

const customCmsIntegration = state => {
  return state.integrations?.find(item => item.type === 'custom-cms') ?? {}
}

const magentoIntegration = state => {
  return state.integrations?.find(item => item.type === 'magento') ?? {}
}

const autoblogSettings = state => state.autoblogSettings || {}

const snackbar = state => state.snackbar

const websocketInstance = state => state.websocket.instance

const websocketConnected = state => state.websocket.connected

const websocketReconnectAttempts = state => state.websocket.reconnectAttempts

const websocketMaxReconnectAttempts = state => state.websocket.maxReconnectAttempts

const websocketMessages = state => state.websocket.messages

const progressTrackers = state => state.progressTrackers

const workspaceUsers = state => state.workspaceUsers || []

export default {
  apiUrl,
  websocketUrl,
  token,
  apiHeader,
  user,
  showSidebar,
  workspaces,
  activeWorkspace,
  contentplans,
  activeContentplan,
  keywords,
  crawl,
  topics,
  articles,
  articlesTotalCount,
  translatedArticles,
  availableLanguages,
  article,
  articleUrls,
  articleExternalUrls,
  score,
  gsc,
  pages,
  pageKeywords,
  benchmarks,
  internalLinks,
  integrations,
  activeIntegration,
  googleAnalyticsIntegration,
  bigQueryIntegration,
  wordpressIntegration,
  notionIntegration,
  searchConsoleIntegration,
  webflowIntegration,
  shopifyIntegration,
  customCmsIntegration,
  magentoIntegration,
  autoblogSettings,
  snackbar,
  websocketInstance,
  websocketConnected,
  websocketReconnectAttempts,
  websocketMaxReconnectAttempts,
  websocketMessages,
  progressTrackers,
  workspaceUsers
}
